import { ResponsiveImageType } from "react-datocms";
import { Image as DatoImage } from "react-datocms";
import Image from "next/image";
import { ROUTES } from "@/config";
import { AnchorButton } from "@narrative-software/narrative-web-ui";

interface EditIntroSectionType {
  title: string;
  description: string;
  image: { responsiveImage: ResponsiveImageType };
  ctaText: string;
}

// Fragment
const editIntroSectionFragment = `
  fragment editIntroSectionFragment on EditIntroSectionRecord {
    title
    description
    image {
      responsiveImage(imgixParams: { auto: format, fit: crop, w: 687, h: 458 }) {
        ...responsiveImageFragment
      }
    }
    ctaText
  }
`;

function EditIntroSection({ title, description, ctaText, image }: EditIntroSectionType) {
  return (
    <section className="py-20 md:py-30 bg-ekans relative">
      <Image
        src={"/images/textures/ekans-bg@2x.png"}
        alt=""
        draggable={false}
        layout="fill"
        quality={100}
        sizes="100vw"
        objectFit="cover"
        objectPosition="center"
      />
      <div className="px-4 flex flex-col-reverse lg:flex-row gap-10 md:gap-6 lg:gap-10 text-white relative text-center items-center md:text-left md:max-w-[1232px] justify-center w-full mx-auto">
        <div className="w-full max-w-[687px] lg:w-[460px]">
          <h2 className="text-h2 font-semibold mb-2 leading-tight">{title}</h2>
          <div className="pr-0 lg:pr-20">
            <div dangerouslySetInnerHTML={{ __html: description }} className="[&_strong]:font-semibold mb-12" />
            <AnchorButton colour="white" href={`/${ROUTES.EDIT.BASE.SLUG}`}>
              {ctaText}
            </AnchorButton>
          </div>
        </div>
        <div className="w-full md:w-[687px]">
          <DatoImage data={{ ...image.responsiveImage }} />
        </div>
      </div>
    </section>
  );
}

export { EditIntroSection, editIntroSectionFragment };
export type { EditIntroSectionType };
